<div [class.arebic-content]="textDirection === 'rtl'">
  <h1 class="title" translate>LEARN_MORE_PAGE.BOOST_BUSINESS</h1>

  @for (item of benefits; track $index) {
    <div class="parent">
      <div class="col-1">
        <img [src]="item.icon" [alt]="item.desc" />
      </div>
      <div class="col-11">
        <h2 translate>{{ item.value }}</h2>
        <p translate>{{ item.desc }}</p>
      </div>
    </div>
  }
</div>
